
























































import { Component, Prop } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Factory from "../../../store/entities/factory";
import { Input } from "view-design";
import aMapCreate from "../company/amap.vue";
@Component({
  components: { aMapCreate },
})
export default class CreatFactorys extends AbpBase {

  @Prop({ type: Boolean, default: false }) value: boolean;
  factory: Factory = new Factory();
  idisable:boolean = false;
  createmap: string = "creatmap";
  aMapCreateModalShow: boolean = false;
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
   openAmap() {
    this.aMapCreateModalShow = true;
  }
  mapaddr(longitude, latitude) {
    //console.log(longitude+latitude);
    this.factory["longitude"]=longitude;
    this.factory["latitude"]=latitude;
  }
  save() {
    (this.$refs.factoryForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.idisable = true;
        await this.$store.dispatch({
          type: "factory/create",
          data: this.factory,
        });
        (this.$refs.factoryForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
         setTimeout(()=>{
           this.idisable=false   //点击一次时隔两秒后才能再次点击
       },2000)
      }
    });
  }
  cancel() {
    (this.$refs.factoryForm as any).resetFields();
    this.$emit("input", false);
  }
  factoryRule = {
    fName: [{ required: true, message: "请填写库区名称", trigger: "blur" }]
  };
}
